import { convertNumber, GeckoMeasurementUnit } from 'types'

const toFeet = (value: number, unit: GeckoMeasurementUnit): number =>
  convertNumber(value, unit, GeckoMeasurementUnit.Feet)

const squareInchesToSquareFeet = (squareInches: number): number => {
  const feetPerInch = toFeet(1, GeckoMeasurementUnit.Inches)
  return squareInches * feetPerInch ** 2
}

export const SHORT_TERM_FEATURE_ALGORITHM_VERSION =
  'forecast-short-term-corrosion-wizard-rectangular-ncc-v5'
export const TARGET_FEATURE_CORE_DFN_PERCENT = -50
export const TARGET_FEATURE_GROW_DFN_PERCENT = -30
export const SHORT_TERM_FEATURE_MIN_CELL_COUNT = 1
export const TARGET_FEATURE_MIN_AREA_FEET_SQUARED = squareInchesToSquareFeet(30)
export const TARGET_FEATURE_MERGE_DISTANCE_FEET = toFeet(
  1,
  GeckoMeasurementUnit.Inches
)
export const TARGET_FEATURE_MAX_RECT_AREA_FEET_SQUARED =
  squareInchesToSquareFeet(500)
export const TARGET_FEATURE_RECT_PADDING_FEET = 0
export const PRIOR_SUPPORT_SEARCH_RADIUS_FEET = toFeet(
  5,
  GeckoMeasurementUnit.Inches
)
export const PRIOR_SUPPORT_TRANSLATION_STEP_BINS = 1
export const PRIOR_SUPPORT_DISTANCE_WEIGHT = 0.02
export const PRIOR_SUPPORT_MIN_COVERAGE_FRACTION = 0.7
export const PRIOR_SUPPORT_MISSING_COVERAGE_WEIGHT = 0.25
export const PRIOR_SUPPORT_MIN_VALUE_COUNT = 3

export const NEUTRAL_PATTERN_MISMATCH = 0.5
export const MATCH_CONFIDENCE_PATTERN_WEIGHT = 0.6
export const MATCH_CONFIDENCE_DISTANCE_WEIGHT = 0.25
export const MATCH_CONFIDENCE_COVERAGE_WEIGHT = 0.15
